//& react & mui imports =======================================================================
import React from "react";

//& hook imports ==============================================================================
import useAdmin from "../../../hooks/useAdmin.js";

//& component =================================================================================
const MenuItem = ({ code, label }) => {
  const { MENU } = useAdmin();

  const className = `menuitem menuitem-${
    MENU.activeMenuItem === code ? "active" : "inactive"
  }`;

  const style = {
    width: `${label.length * 10}px`,
  };

  //& rendering ===============================================================================
  return (
    <div
      className={className}
      onClick={() => MENU.onMenuItemClick(code)}
      style={style}
    >
      {label}
    </div>
  );
};

export default MenuItem;
